import { render } from "./filterCategory.vue?vue&type=template&id=68876496"
import script from "./filterCategory.vue?vue&type=script&lang=js"
export * from "./filterCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__